export default {
  accesibility: 'Accesibility',
  add: 'Add',
  add_api_ckan: 'Available KCAN API',
  add_department: 'Department',
  add_font: 'Source',
  add_geo: 'Geolocation',
  add_gerence: 'Administration',
  add_historic: 'Historical information',
  add_long_available: 'Long format available',
  add_more_info: 'More info',
  add_publication_date: 'Publication date',
  add_publication_freq: 'Update frequency',
  freq_peticio_negoci: 'According to availability',
  add_recent_views: 'Recent visits (last 2 weeks)',
  add_title: 'Title',
  add_token: 'Required token',
  add_total_views: 'Total visits',
  additional: 'Additional content',
  additional_info: 'Additional information',
  complement_info: 'Complementary description',
  all_dates: 'All available dates',
  all_details: 'All details',
  all_ditricts: 'All districts',
  all_sources: 'All types',
  all_subthemes: 'All sub-topics',
  all_themes: 'All topics',
  alphabetical_asc: 'Alphabetical A->Z',
  alphabetical_des: 'Alphabetical Z->A',
  APPS: 'App',
  back: 'Back',
  bcn_search_placeholder: 'Search on barcelona.cat…',
  btn_apply: 'Apply',
  btn_clean: 'Clear',
  camps_definition_title: 'Field definition',
  cancel: 'Cancel',
  check_results_apl: 'See Results in Application',
  check_results_app: 'See Results in App',
  edit_table_title: 'Edit table',
  contact: 'Contact',
  copy_link: 'Copy link',
  cover_title: 'Barcelona Datastore',
  data_api: 'Data API',
  date_latest: 'Date - oldest',
  date_newest: 'Date - newest',
  dates_from: 'Data of ',
  det_downloads: 'Download total by ID',
  det_downloads_abs: 'Download total',
  det_format: 'Format',
  det_last_update: 'Last update',
  det_map_view: 'Show map',
  det_open_freq: 'Openness',
  det_publish_date: 'Publication date',
  det_req_token: 'Required token',
  detail: 'Details',
  district: 'Barcelona districs',
  DOCS: 'Document',
  docs_lab: 'Documents',
  download: 'Download',
  download_links: 'Download link',
  download_pdf: 'Download PDF',
  drag_dimensions: 'Add dimension',
  enq_afi: 'Allocation',
  enq_companies: 'Designated companies',
  enq_contract_conditions: 'Contract conditions',
  enq_date_campo: 'Date of fieldwork',
  enq_error_sample: 'Sampling error',
  enq_methodology: 'Methodology',
  enq_num_register: 'Register number',
  enq_pond: 'Weighting',
  enq_presu: 'Budget (euros)',
  enq_promotor: 'Promoter',
  enq_sample_procedure: 'Sampling procedure',
  enq_size_mue: 'Sample size',
  enq_tipology: 'Type',
  enq_universe: 'Universe',
  enq_validation_date: 'Date of validation',
  enq_date_from: 'Initial date',
  enq_date_to: 'Final date',
  doc_auth: 'Author',
  doc_subj: 'Subject',
  doc_geo: 'Geographical coverage',
  doc_publish: 'Published by',
  doc_ext: 'Extension',
  doc_note: 'Note',
  doc_terms_use: 'Terms of use',
  doc_related: 'Related document',
  doc_colections: 'Appears in collections',
  show_pdf: 'See PDF',
  show_txt: 'See TXT',
  SURVEY: 'Survey',
  error_response: 'Error during request',
  error_server_response: 'Search server error',
  STATISTICS: 'Statistical table',
  file_chart: 'Chart',
  file_details: 'File details',
  file_details_title: 'File details',
  file_map: 'Map',
  file_table: 'Table',
  filter_by: 'Filter by',
  lang_ca: 'Català',
  lang_en: 'English',
  lang_es: 'Castellano',
  last_3_months: 'Last 3 months',
  last_informed_date: 'Last informed date ',
  last_month: 'Last month',
  last_year: 'Last year',
  legal_adv: 'Legal disclaimer',
  license: 'License',
  loading: 'Loading...',
  manual_range: 'Range',
  MAPS: 'Maps',
  MICRODATA: 'Raw data',
  no_results_search: 'We could not find results for your search',
  no_results_tip: 'We recommend applying other search filters or changing the search term',
  relevance: 'Relevance',
  results_for: 'results for ',
  rows_of: 'rows of ',
  search_placeholder: 'Search by word...',
  share: 'Share',
  sort_by: 'Order by:',
  subtheme: 'Sub-topic',
  table_columns: 'Columns',
  table_filters: 'Other dimensions',
  table_rows: 'Rows',
  table_reset: 'Back to the original',
  table_ord_asc: 'Sort ascending',
  table_ord_desc: 'Sort descending',
  table_select_range: 'Select range:',
  tooltip_edit_table: 'Edit table',
  tooltip_edit_chart: 'Edit graph',
  tooltip_edit_map: 'Edit map',
  tooltip_two_dim: 'Max $n dimensions',
  theme: 'Topic',
  type: 'Type',
  download_file: 'Download file',
  type_content: 'Type of content',
  update_date: 'Update date',
  use_identifier: 'Please use this ID to cite or quote this item: ',
  views_last_year: ' views',
  welcome_to_portal: 'Or select one topic',
  line_apearence: 'Line style',
  line_values: 'Show points values',
  line_labels: 'Show line labels',
  chart_legend_title: 'Legend',
  chart_horizontal: 'Horizontal',
  chart_vertical: 'Vertical',
  chart_line_round: 'Rounded',
  chart_line_rect: 'Straight',
  chart_categorical: 'Categorical',
  chart_unicolor: 'Single color',
  chart_orientation: 'Orientation',
  chart_color: 'Color',
  chart_x_axis: 'Orientation label X axis',
  chart_y_axis: 'Orientation label Y axis',
  chart_labels: 'Show bars labels',
  chart_values: 'Show bars values',
  chart_heat_values: 'Show values',
  chart_legend: 'Show legend',
  chart_config: 'Settings',
  data_config: 'Data',
  table_chart: 'Plotted dimension',
  calculating: 'Computing...',
  used_unit: 'Unit: ',
  bar_chart: 'Bar chart',
  stacked_bar_chart: 'Stacked bar chart',
  grouped_bar_chart: 'Clustered bar chart',
  line_chart: 'Line chart',
  pie_chart: 'Donut chart',
  pyramid_chart: 'Pyramid',
  treemap: 'Treemap',
  radar_chart: 'Radar',
  connected_dotplot: 'Connected Dotplot ',
  heatmap: 'Heat map',
  first_trim: '1st tr',
  second_trim: '2nd tr',
  third_trim: '3rd tr',
  fourth_trim: '4th tr',
  first_sem: '1st sem',
  second_sem: '2nd sem',
  table_compact: 'Compact',
  table_detail: 'Detailed',
  table_column: 'Column',
  select_all: 'Select all',
  of: ' from ',
  num_cols: ' columns',
  el_labels: 'Show element labels',
  value_in_labels: 'Show value in labels',
  configure_your_table: 'Configuration error on data. Check your dimensions.',
  no_data_for_these_filters: 'There are no data for these filters',
  too_much_data:
    'This chart cannot be displayed (max 500 cells). Please change the filter selection or use another chart.',
  bcn_data: 'Barcelona up to date',
  show_less: 'Show less',
  show_more: 'Show more',
  unselect_all: 'Unselect all',
  all_op: 'All',
  no_op: 'No one',
  selected: ' selected',
  map_prev: 'Link to map aplication',
  color_op: 'Color options',
  colors_by_value: 'Color according to value',
  colors_by_category: 'Color according to category',
  transparency: 'Transparency',
  steps: 'Steps',
  head_us: 'About us',
  head_help: 'Help',
  week: 'Week',
  meta_id: 'Link to aplication',
  DATASTORIES: 'Data Stories',
  datastory_info: 'Check Data Story Report',
  service_unsupported: 'Service unsupported',
  map_step_linear: 'Linear',
  map_step_rounded: 'Rounded values',
  map_step_quantile: 'Quantiles',
  map_step_breaks: 'Natual breaks',
  show_points: 'Show points',
  meta_filters: 'Filters -> ',
  meta_filter_types: 'Filter types -> ',
  calendar: 'Calendar',
  no_map_preview: 'Map previsualization not available',
  color_flip: 'Change color order',
  datastory_title: 'Data Stories',
  dtst_interactiveapps: 'Interactive applications',
  dtst_reports: 'Reports',
  dtst_pdfdocuments: 'PDF documents',
  dtst_observatory: 'Observatory',
  datastory_desc_prev: 'Analytic information by topic in various query formats',
  news_title: 'News',
  news_desc: "Keep up to date with what's happening in Barcelona",
  calendar_title: 'Schedule',
  calendar_desc: 'Notified when we are publishing topics of your interest',
  new: 'New',
  update: 'Update',
  retard: 'Data change',
  add_to_calendar: 'Add to calendar',
  notice_prev: 'Previous new',
  notice_next: 'Next new',
  see_id: 'See the indicator',
  datastory_desc:
    'The Data Stories offer an analytical view on different aspects of the city. They are offered in different formats such as interactive applications, reports, PDF documents and observatories.',
  datastory_desc2: 'Select this link if you want to access the entire selection of Data Stories ',
  copy: 'Copy data',
  more_op: 'More options',
  map_step_custom: 'Custom map jump',
  custom_steps: 'Custom jumps',
  normalize_axes: 'Normalize axes',
  no_date_selected: 'No date selected',
  no_date_events: 'There are no events for the selected date',
  geo_not_supported: 'Map not available',
  page_not_available: 'This page does not exist, return to the home page.',
  backend_error: 'The resource is not accessible in openData',
  not_csv: 'csv not found',
  not_cms: 'CMS content not available',
  related_content: 'Related content',
  data_and_resources: 'More recent data',
  lat: 'Latitude',
  lng: 'Length',
  login: 'Login',
  email: 'Email',
  email_ex: 'name@email.com',
  client_id: 'ClientID',
  ask_client_id: 'Request ClientID',
  client_id_required: 'It is necessary to have a ClientId to use this API',
  how_to_get_client:
    'To get a ClientId, in your user area, on the personal data tab, you will find a button to request this unique and personal key.',
  user_zone: 'Access to your ',
  password: 'Password',
  password_ex: 'Insert your password',
  password_forgot: 'Have you forgotten the password?',
  session_remember: 'Stay signed in',
  not_member: 'Still are you not a member?',
  want_register: 'I want to register',
  register: 'Register',
  required_field: '* Required field',
  reg_name: 'Name',
  reg_name_ex: 'Type your name',
  reg_sur: 'Surname',
  reg_sur_ex: 'Type your surname',
  reg_email_con: 'Confirm email*',
  reg_lang: 'Language',
  reg_sex: 'Sex',
  sex_M: 'Male',
  sex_F: 'Female',
  sel_placeholder: 'Select an option',
  reg_pass_con: 'Confirm your password*',
  password_req: 'The password must contain at lest',
  pass_req1: '8 characters',
  pass_req2: '1 upercase',
  pass_req3: '1 lowercase',
  pass_req4: '1 number',
  terms_and_cond: 'privacy clause',
  reg_dates_prot:
    'I am informed about the protection policy of data and I consent the processing of my personal data',
  reg_more_inf: 'You can find information on treatment 0690 in this link: ',
  want_login: 'Do you have an account? ',
  my_space: 'My space',
  user_dates: 'User data',
  fav_list: 'Favourites list',
  view_lib: 'Views library',
  comun_pref: 'Comunication preferences',
  drop_out: 'Drop out',
  last_mod: 'Last modification ',
  email_low: 'email',
  save: 'Save',
  tem_new_cont: 'What topics do you want to receive information about when we add new content?',
  temp_freq_news: 'Select the time frame and frequency of the notices you wish to receive',
  temp_none: 'None',
  temp_month: 'Monthly',
  temp_week: 'Weekly',
  favs_for: 'favourites for ',
  update_noti: 'Notify updates',
  saved: 'Saved',
  agree: 'Agree',
  location: 'Territory',
  all_locations: 'All territories',
  supramunicipal: 'Supramunicipal',
  municipi: 'Municipality',
  districte: 'District',
  barri: 'Neighborhood',
  area_estadistica_basica: 'Basic Statistical Area',
  seccio_censal: 'Census Tract',
  codi_postal: 'Postal code',
  and: 'and',
  dia: 'Daily',
  setmana: 'Weekly',
  mes: 'Monthly',
  trimestre: 'Quarterly',
  any: 'Annually',
  all_filters: 'All themes',
  logout: 'Logout',
  activate_title: 'Confirm your email to complete the registration',
  confirm: 'Confirm',
  invalid_title: 'User not validated',
  invalid_desc:
    'Your details are correct but your email has not been confirmed. Check your inbox or click on the button below to send another validation email to the registered email.',
  send: 'Send me again',
  forgot_desc:
    'Enter your email address to send a recovery email and be able to change your password.',
  registred_user: 'User registered successfully',
  validate_desc:
    'Check your inbox or click on the button below to send another validation email to the registered email.',
  valid_title: 'Your user is already active',
  valid_desc: 'Go to the login page and start saving your details.',
  password_title: 'Your password has already been updated',
  password_desc: 'Go to the login page to see the changes.',
  change_pw_title: 'Change your password',
  change_pw_desc: 'Fill in the following fields to complete the password change',
  new_pw: 'New password',
  conf_new_pw: 'Confirm new password',
  error_login: 'Incorrect username or password',
  delete_user:
    'Enter your email address and click the confirm button to remove your user from the database',
  delete_user_confirm:
    'The user has been successfully removed from the system and is no longer registered.',
  delete_thanks: 'Thank you for using our services.',
  drop_out_confirm: 'Are you sure you want to unsubscribe?',
  head_links: 'Useful links',
  pref_noti_title: 'Allow notifications of updated content',
  pref_noti_desc:
    'When notifications are active, you can choose to receive the ones that are relevant to you',
  pref_noti_active: 'Activated',
  error_token: 'Invalid or expired token',
  create_newest: 'Recent creation date',
  create_latest: 'Oldest creation date',
  data_error: 'Error in data',
  pref_noti_favs_default_title: 'Notify updates of new favorites',
  pref_noti_favs_default_desc:
    'Change the notifications default status in your new added favourites ',
  email_send: 'Email sent',
  email_desc: 'Check your inbox and review the latest emails received',
  sex_NS: 'Not defined',
  no_views_fav:
    'No views found for selected filters, add new favorites from statistic indicator views',
  no_favs: "You don't have items in your favorites list yet.",
  no_favs_ex: 'Start adding them from the different indicator pages',
  reg_req: 'This field cannot be empty.',
  reg_email: 'This field cannot be empty and must follow the email format.',
  reg_email_conf: 'This field cannot be empty and must match the other email entered.',
  reg_pass: 'This field cannot be empty and must follow the required password format.',
  reg_pass_conf: 'This field cannot be empty and must match the other password.',
  reg_check: 'It is necessary to accept the conditons to complete the registration.',
  api_micro_title: 'Microdata/Export',
  api_def: 'API method definition:',
  api_micro_def_res: '/microdata/export',
  api_func: 'Functionality:',
  api_micro_func_res:
    'Gets the CSV file with the data of one of the resources of a specific microdata type indicator based on the identifier of the indicator and the resource. The user of the Data Portal will select the item, of type microdata, of what you want to see the information of the list of elements that will be presented to you in the frontend, after this you will select the file to download.',
  api_micro_ex: 'Example:',
  api_res:
    'You can see an example of the result of a call to this endpoint with the parameters of this file:',
  api_stat_title: 'Statistic/Export',
  api_stat_def_res: '/statistic/export',
  api_stat_func_res:
    'Gets a file in CSV or Excel format with the indicator data table associated with the id passed as a parameter.',
  api_stat_ex_1: 'Example (Excel):',
  api_stat_ex_2: 'Example (CSV):',
  api_extra: 'To download these files from another application, use this command:',
  statistics: 'Statistics',
  copied: 'Copied!',
  unique_values: 'Unique values',
  valid: 'Valid',
  missing: 'Missing',
  most_common: 'Most common',
  average: 'Average',
  deviation: 'Deviation',
  others: 'Others',
  count: 'Count',
  single_value: 'Single value',
  unique_date: 'Unique date: ',
  microdata_loader:
    'We are calculating the details of the columns. These will be visible after approximately 30 seconds.',
  home: 'Home',
  stat_content: 'Content statistics',
  stat_use: 'Usage statistics',
  profiles_use: 'User profiles',
  last_week: 'Last week',
  pbd_content_title_char_1: 'Evolved name of items per type of fitxer',
  pbd_content_title_char_2: 'Distribution by type of fitxer',
  pbd_content_title_char_3: 'Evolution of the items by thematic',
  pbd_content_title_char_4: 'Distribution by themes',
  pbd_use_title_char_1: 'Number of web hits',
  pbd_use_title_char_2: 'Evolution of the number of registered users',
  pbd_use_title_char_3: 'Most Viewed Items',
  pbd_use_title_char_4: 'Most downloaded items',
  pbd_use_title_char_5: 'Most Searched Words',
  pbd_profiles_title_char_1: 'Language',
  pbd_profiles_title_char_2: 'Device',
  pbd_profiles_title_char_3: 'Country',
  pbd_profiles_title_char_4: 'Time',
  all_types: 'All types',
  add_range: 'Rang of values',
  add_filter: 'Filter by type',
  add_search: 'Filter by word',
  users: 'Users',
  interactions: 'Interactions',
  user_blocked: 'User blocked by the administrator',
  MON: 'Mon',
  TUE: 'Tue',
  WED: 'Wed',
  THU: 'Thu',
  FRI: 'Fri',
  SAT: 'Sat',
  SUN: 'Sun',
  quote_and_license: 'Terms of use',
  location_type: 'Location type',
  map_base: 'Base',
  map_no_base: 'No Base',
  page_429: 'Data temporarily unavailable, please try again later',
  overwrite: 'Overwrite',
  copy_embed: 'Copy embed code',

  meta_description:
    'It integrates and disseminates data and analysis of the current situation and the evolution of Barcelona from the demographic, economic, social, political and public opinion aspects.',
  meta_keywords:
    "Municipal Data Office, MDO, Statistics Department, Data dissemination, Surveys, Survey Register, Public opinion poll register Barcelona's town hall, Technical Programming Office, statistics, open data, Barcelona, BCN, statistical yearbook, population, economy, labour market, urban environment, transport, mobility, housing, society, politics, Municipal administration, Barcelona cartography.",
  embed: 'Embed',
  dropdown_index: 'Dropdown Index',
  index: 'Index',
  not_cms_lang: 'Report no available for this language',
  register_required: 'It is necessary to have a personal user to make use of this api',
  how_to_register: 'To have this user you just need to fill out the following form: ',
  if_user: 'If you already have a user, click the button above to log in.',
  client_id_pending: 'Client id requested and pending validation',
  login_advantages: 'Discover the benefits of being registered by clicking ',
  here: 'here',
  session_ended: 'The last session has ended, please click here to access again:',
  tornarPrincipal: 'Back to main screen',
  add_dades_alt_valor: 'High value data',
}
